import React from 'react';

import Popover, {
  IPropTypes as PopoverProps
} from 'e100-react-components/lib/components/Popover';
import { ModalDialog } from 'e100-react-components';
import { checkIsActiveHereMap } from 'entities/map';

import { useMediaQuery } from 'common/hooks';
import { useStyles } from './styles';

export const InfoWindow = ({
  id,
  title,
  open = false,
  anchorEl,
  onClose,
  children,
  anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'center',
  },
  transformOrigin = {
    vertical: 'top',
    horizontal: 'center',
  }
}: InfoWindowProps) => {
  const classes = useStyles({
    transformOriginVertical: transformOrigin.vertical,
    transformOriginHorizontal: transformOrigin.horizontal
  });
  const { isMobile, isTablet } = useMediaQuery();

  if (isMobile || (checkIsActiveHereMap() && isTablet)) {
    return (
      <ModalDialog
        open={open}
        showCloseButton
        disableEnforceFocus
        onClose={onClose}
        fullScreen
        title={title}
        classes={{
          title: {
            root: classes.titleRoot
          },
          dialog: {
            root: classes.dialogRoot,
            paper: classes.dialogPaper
          },
          content: {
            root: classes.contentRoot
          }
        }}
      >
        {children}
      </ModalDialog>
    );
  }

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      classes={{
        paper: classes.popoverRoot,
      }}
    >
      {children}
    </Popover>
  );
};

interface InfoWindowProps extends Pick<
PopoverProps,
'onClose' | 'anchorOrigin' | 'transformOrigin'
> {
  id?: string;
  open?: boolean;
  anchorEl?: Element;
  children?: React.ReactNode;
  title?: React.ReactNode;
}